import { IForgotPasswordLiveParams } from '@aqx-core/common/api/auth';

export enum EForgotPasswordContent {
  FORM = 'FORM',
  COMPLETE = 'COMPLETE'
}

export interface IForgotPasswordParams {
  params: IForgotPasswordLiveParams;
  onError: (message: string) => void;
}

export interface ISendPasswordEmail extends IForgotPasswordParams {
  onSuccess: () => void;
}
